module.exports = __webpack_public_path__ + "img/zl_qt_bg.13a1a8b0.png";